import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/student-enrollments', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/student-enrollments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .post('/api/student-enrollments/update-classes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/student-enrollments/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const forwardClass = data => {
  return httpClient
    .post('/api/student-enrollments/forward-classes', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const accelerateStudent = data => {
  return httpClient
    .post('/api/student-enrollments/accelerate-students', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getClass = (Options = {}) => {
  return httpClient
    .get('/api/student-enrollments/classes', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getStudent = (Options = {}) => {
  return httpClient
    .get('/api/student-enrollments/students', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getClassOfNextGrade = ({ gradeId, params }) => {
  return httpClient
    .get(`/api/student-enrollments/${gradeId}/next-class-in-next-grades`, {
      params
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  update,
  destroy,
  forwardClass,
  getClass,
  getStudent,
  getClassOfNextGrade,
  accelerateStudent
}
